module.exports = __webpack_public_path__ + "img/kl_map.7b002115.webp";